import React from 'react'
import {
  ActionListItem,
  Avatar,
  Box as Table,
  Box as TableBody,
  Text,
} from '@node-space/ui-components'
import { getAvatarInitial } from 'utils/utils'
import { EmbeddedCustomer } from '../helpers/types'
import { CustomerStatusHighlight, CustomerTypeHighlight } from './CustomerHighlight'

export interface EmbeddedCustomersListProps {
  customers: EmbeddedCustomer[]
  onOpenDetails: (customerIndex: number) => void
}

export const EmbeddedCustomersList = ({ customers, onOpenDetails }: EmbeddedCustomersListProps) => {
  return (
    <Table tag="table" data-testid="embedded-contacts-list">
      <TableBody tag="tbody">
        {customers?.map(({ id, type, status, name, description }, customerIndex) => (
          <ActionListItem
            key={id}
            id={id}
            title={name}
            HeaderHighlightLeft={<CustomerTypeHighlight type={type} />}
            ActionHighlight={<CustomerStatusHighlight status={status} />}
            Avatar={<Avatar size="large" type="entity" name={getAvatarInitial(name)} />}
            BodyPre={<Text color="subdued">{description}</Text>}
            border
            onItemClick={() => onOpenDetails(customerIndex)}
          />
        ))}
      </TableBody>
    </Table>
  )
}
